module.exports = __webpack_public_path__ + "img/rec-07.5f1d529f.jpg";